import { InstrumentType } from '@app/shared/models/contracts/enums/shared-enums';
import {
  InstrumentDefinitionWithId,
  selectInstruments,
} from '../capital-structure-slice-selectors';
import { enumKeyByValue } from '@app/shared/helpers';
import { createSelector } from '@reduxjs/toolkit';

export const instrumentFilters = {
  byType: (type: InstrumentType) => (instrument: InstrumentDefinitionWithId) =>
    instrument.type === enumKeyByValue(InstrumentType, type),

  excludeType: (type: InstrumentType) => (instrument: InstrumentDefinitionWithId) =>
    instrument.type !== enumKeyByValue(InstrumentType, type),

  shouldBeValued: (instrument: InstrumentDefinitionWithId) => instrument.shouldBeValued,

  hasInitialValues: (capitalStructure: any) => (instrument: InstrumentDefinitionWithId) =>
    capitalStructure.initialValues && instrument.instrumentId in capitalStructure.initialValues,
};

export const createInstrumentFilterSelector = (
  filterFn: (instrument: InstrumentDefinitionWithId) => boolean
) => createSelector([selectInstruments], (instruments) => instruments?.filter(filterFn) ?? []);
